<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- Actions header (sticky within scrollable content) -->

        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">
          <div class="d-flex justify-content-between align-items-center sticky-top mb-2">

            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>
         <button
              v-can-create.permission="'surveys'"
              class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm ms-auto"
              @click="openCreateModal">
              <span class="small text-xxs d-flex align-items-center gap-1">
                Create Survey
              </span>
            </button>
                      </div>

          <div class="row g-2 mb-3">
            <div
              v-for="card in survey_dashboard_cards"
              :key="card.label"
              class="col-6 col-md-4 col-xl"
            >
              <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                  <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                    <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                    <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                  </div>
                  <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                    <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- table -->
         <div class="d-flex justify-content-end mb-2">
          </div>
           <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Survey List...</p>
            </div>
            <div v-show="!isLoading">
              <div v-if="surveys && surveys.length === 0" 
                class="d-flex flex-column align-items-center justify-content-center text-center py-5 w-100">
                
                <i class="bi bi-clipboard2-data display-1 text-light-emphasis mb-3" aria-hidden="true"></i>
                
                <h5 class="text-muted fw-normal">No surveys found</h5>
                <p class="text-muted small">When you create a new surveys, they will appear here.</p>
            </div>
          <div v-else class="table-responsive">
            <table id="survey-table" class="table align-middle table-striped table-borderless mb-0">
              <thead class="text-uppercase btn-primary text-white ">
                <tr>
                  <th class="text-xxs fw-light">No.</th>
                  <th class="text-xxs fw-light text-center">Survey Name</th>
                  <th class="text-xxs fw-light text-center">description</th>
                  <th class="text-xxs fw-light text-center">Actions</th>
                </tr>
              </thead>

              <tbody>
                <!-- Apply text-xxs at the row level for all cells -->
                <tr v-for="(survey, index) in surveys" :key="survey.id" class="border-bottom text-xxs">
                  <!-- Number -->
                  <td class="text-center">
                    <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                      {{ index + 1 }}
                    </span>
                  </td>

                  <!-- Survey Name -->
                  <td class="text-center">
                    <div class="text-xxs">{{ survey.name }}</div>
                  </td>

                  <!-- Type -->
                  <td class="text-center">
                    <span class="chip chip-info text-xxs">
                      {{ survey.description || 'N/A' }}
                    </span>
                  </td>
                  <!-- Actions -->
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-1">
                      <button
                        type="button"
                        class="btn btn-light btn-sm rounded-3 text-primary border"
                        @click="open_survey_responses_modal(survey)"
                      >
                        <span class="text-xxs">View</span>
                      </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-success border"
                        @click="openEditModal(survey)"
                      >
                        <span class="text-xxs">Edit</span>
                      </button>

                      <button
                        class="btn btn-light btn-sm rounded-3 text-danger border"
                        @click="deleteSurvey(survey.id)"
                      >
                        <span class="text-xxs">Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>
          </div>
        </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div> <!-- /app shell -->


<!-- Create / Edit Survey Modal -->
 <teleport to="body">
<div class="modal fade dashboard-survey-modal" id="create_survey" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered dashboard-survey-modal-dialog">
    <div class="modal-content dashboard-survey-modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="exampleModalLabel">
            {{ isEditMode ? 'Edit Survey' : 'Create a Survey' }}
          </p>

          <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>

      </div>
      <div class="modal-body modal-body-scroll dashboard-survey-modal-body">
      <div class="card border-1 rounded bg-white p-3 shadow-sm position-relative dashboard-survey-form-card">
      <form @submit.prevent="submitSurvey()" novalidate>
                    <div class="mb-4 dashboard-survey-form-intro">
                        <p class="fw-bold text-dark text-xs mb-1">{{ survey_id ? 'Edit survey' : 'Create a new survey' }}</p>
                        <p class="text-muted text-sm text-xs mb-0">Shape the questions, add the right options, and keep the experience simple for the people answering it.</p>
                    </div>
                    <!-- Survey Title -->
                    <div class="mb-3">
                        <label for="survey_name" class="form-label text-xxs fw-bold">Survey Name<span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control rounded text-xxs" id="survey_name"
                            placeholder="Enter survey name" v-model="survey_name">
                        <p v-if="errors.survey_name" class="text-danger text-xxs mt-1">{{ errors.survey_name }}</p>
                    </div>

                    <!-- Survey Description -->
                    <div class="mb-3">
                        <label for="survey_description" class="form-label text-xxs fw-bold">Survey Description</label>
                        <QuillEditor theme="snow" v-model="survey_description" ref="quillSurveyEditorRef"
                            class="quill-editor" placeholder="Enter your description here..." toolbar="half" />
                    </div>
                    <div class="mb-3">
                        <button type="button" class="btn btn-primary btn-sm float-end text-xxs rounded-3 shadow-sm"
                            @click="showQuestionForm = !showQuestionForm">
                            {{ showQuestionForm ? 'Hide Question Form' : 'Add Question' }}
                        </button>
                        <div v-if="showQuestionForm">

                            <div class="row mt-2 w-100 ">
                                <!-- Question Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question <span class="text-danger">*</span></label>
                                    <div class="d-flex">
                                        <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                                            v-model="newQuestion.text" placeholder="Enter question text"
                                            list="questionSuggestions" @input="onQuestionInput"
                                            @change="onQuestionSelect" />
                                    </div>
                                    <datalist id="questionSuggestions">
                                        <option v-for="question in filteredQuestions" :key="question.id"
                                            :value="question.question"></option>
                                    </datalist>
                                </div>

                                <!-- Question Number Input -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Question Number <span class="text-danger">*</span></label>
                                    <input type="number" class="form-control text-xxs rounded p-2 bg-white"
                                        placeholder="Eg. 1" v-model="newQuestion.question_number" />
                                </div>

                                <!-- Question Type Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Type <span class="text-danger">*</span></label>
                                    <select v-model="newQuestion.type" class="form-select text-xxs p-2 rounded mb-2">
                                        <option value="" disabled>Select</option>
                                        <option
                                            v-for="type in question_types.filter(is_allowed_survey_question_type)"
                                            :key="type.id" :value="type.id">
                                            {{ get_question_type_label(type) }}
                                        </option>
                                    </select>

                                    <!-- Options Input for Multiple Choice, Checkbox, or Selection -->
                                    <div v-if="survey_question_supports_options(newQuestion.type)"
                                        v-for="(option, index) in newQuestion.options" :key="option.id || index"
                                        class="d-flex align-items-center gap-2 mb-1 w-100">
                                        <input type="text" class="form-control text-xxs rounded p-2"
                                            v-model="option.text" placeholder="Enter option text" />
                                        <button class="btn btn-light board-icon-btn align-items-center justify-content-center" type="button"
                                            @click="removeOption(index)">
                                            <i class="bi bi-x-lg"></i>
                                        </button>
                                    </div>

                                    <div
                                        v-if="survey_question_supports_options(newQuestion.type)"
                                        class="d-flex justify-content-end">
                                        <button
                                            class="btn btn-sm btn-warning text-white text-xxs rounded-3 shadow-sm fw-500"
                                            type="button" @click="addOption">
                                            Add Option
                                        </button>
                                    </div>
                                </div>

                                <!-- Is Mandatory Select -->
                                <div class="form-group col-sm-6 mb-1 my-3">
                                    <label class="text-xxs">Is the question mandatory?</label>
                                    <select v-model="newQuestion.is_mandatory" class="form-select text-xxs p-2 rounded mb-2">
                                        <option :value="true">Yes</option>
                                        <option :value="false">No</option>
                                    </select>
                                </div>

                                <!-- Add Question Button -->
                                <div class="col-12">
                                    <button type="button" class="btn btn-sm btn-success text-xxs rounded float-end"
                                        @click="addQuestionToSurvey"
                                        :disabled="!newQuestion.text || !newQuestion.type || !newQuestion.question_number">
                                        Add Question to Survey
                                    </button>
                                </div>
                            </div>
                            <div class="mt-3" v-if="createdQuestions.length > 0">
                                <h6 class="text-xxs fw-semibold">Created Questions</h6>
                                <!-- <ul>
                                <li > -->
                                <div v-for="(question, index) in createdQuestions" :key="index"
                                    class="d-flex justify-content-between align-items-center border rounded p-2 text-xxs mb-2">
                                    <div class="min-w-0">
                                        <span class="text-xxs">{{ index + 1 }}. {{ question.text }}</span>
                                    </div>
                                    <div class="d-inline-flex align-items-center gap-2 flex-shrink-0">
                                        <span class="text-muted text-xxs">
                                            {{ get_selected_question_type_label(question.type) }}
                                        </span>
                                        <span v-if="question.is_mandatory"
                                            class="text-muted text-xxs">Required</span>
                                        <button type="button" class="btn btn-sm text-danger"
                                            @click="remove_created_question(index)" title="Remove">
                                            <i class="bi bi-trash text-danger"></i>
                                        </button>
                                    </div>
                                </div>
                                <!-- </li>
                            </ul> -->
                            </div>
                        </div>

                    </div>

                    <!-- Submit -->
                    <div class="d-flex justify-content-end gap-2 mt-3">
                        <button
                            v-if="survey_id || createdQuestions.length > 0"
                            type="submit"
                            class="btn btn-sm btn-primary text-xxs rounded-3 shadow-sm me-2"
                        >
                            {{ survey_id ? 'Update' : 'Create' }} Survey
                        </button>
                    </div>

                </form>
        </div>
        </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="view_survey_responses_modal" tabindex="-1" aria-labelledby="viewSurveyResponsesLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="viewSurveyResponsesLabel">
          {{ selected_view_survey?.name || 'Survey Responses' }}
        </p>
        <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body modal-body-scroll">
        <p v-if="selected_view_survey?.description" class="text-muted text-xxs mb-3" v-html="selected_view_survey.description"></p>
        <div v-for="(question, index) in get_survey_response_questions(selected_view_survey)" :key="question.id || index" class="border rounded bg-light p-3 mb-3">
          <p class="fw-bold text-xxs mb-2">{{ index + 1 }}. {{ get_survey_response_question_text(question) }}</p>
          <div v-if="question.answers && question.answers.length">
            <div v-for="(answer, answerIndex) in question.answers" :key="answer.id || answerIndex" class="border-top py-2 text-xxs">
              <span class="fw-semibold">{{ get_response_user_name(answer) }}:</span>
              <span class="text-muted">{{ get_survey_response_answer_text(answer) }}</span>
            </div>
          </div>
          <p v-else class="text-muted text-xxs mb-0">No responses yet.</p>
        </div>
        <p v-if="!get_survey_response_questions(selected_view_survey).length" class="text-muted text-xxs mb-0">No questions found.</p>
      </div>
    </div>
  </div>
</div>
</teleport>
